<norupe-header />
<section class="absolute top-16 bottom-0 w-full overflow-hidden">
  <div
    class="relative h-[50%] w-full overflow-x-hidden border-b border-gray-200 px-4 py-6 sm:px-6 md:float-left md:h-full md:w-lg md:border-r md:border-b-0 md:pl-6"
  >
    <norupe-greenhouse />
  </div>

  <article class="relative h-[50%] w-full overflow-x-hidden md:h-full md:w-auto md:overflow-hidden">
    <div style="width: 100%; height: 100%" class="h-full w-full" id="map"></div>
  </article>

  @if (rtuDataStore.loadingMap()) {
    <svg
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      class="absolute top-2 right-0 mr-3 -ml-1 size-5 animate-spin text-blue-800"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="opacity-25" />
      <path
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        fill="currentColor"
        class="opacity-75"
      />
    </svg>
  }
</section>

<div class="min-w-40 rounded-sm border bg-white p-1 text-sm dark:bg-slate-900 dark:text-white" id="overlay-popup">
  <div class="divide-y">
    <div class="p-2">
      <dl class="text-xs">
        @if (featuresOnCursor.length > 0) {
          @for (item of featuresOnCursor[0].getProperties() | keyvalue; track $index) {
            @if (
              item.key === "ndvi" || item.key === "temperature" || item.key === "delta_temperature" || item.key === "species" || item.key === "status"
            ) {
              <dt class="float-left mr-1 font-bold">{{ "MONITORING." + item.key | translate }}:</dt>
              @if (item.key === "status") {
                <dd>{{ rtuDataStore.cellstatus() | getValueFromId: item.value }}</dd>
              } @else if (item.key === "species") {
                <dd>{{ rtuDataStore.treespecies() | getValueFromId: item.value }}</dd>
              } @else {
                <dd>{{ item.value }}</dd>
              }
            }
          }
        }
      </dl>
    </div>
  </div>
</div>
